<template>
  <v-container fluid>
    <portal to="app-header">
      <template>
       {{ $t('checklistReport.title') }}
      </template>
    </portal>
    <v-fade-transition mode="out-in">
      <checklist></checklist>
    </v-fade-transition>
  </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Checklist from './Checklist.vue';

export default {
  name: 'Index',
  components: {
    Checklist,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('checklistReport', ['lastRefreshedAt', 'loading']),
    ...mapState('helper', ['selectedAsset', 'assetKey']),
    ...mapState('webApp', ['storageLocation']),
  },
  async created() {
    const appId = localStorage.getItem('appId');
    await this.getSchemaAndLabel(appId);
  },
  methods: {
    ...mapActions('checklistReport', ['fetchPlans']),
    ...mapActions('helper', ['getSchemaAndLabel']),
    ...mapMutations('checklistReport', []),
  },
  watch: {},
};
</script>
